let menu = {
  load() {
    document.addEventListener("DOMContentLoaded", function () {
      const menuItems = document.querySelectorAll(
        'nav ul > li > a[aria-haspopup="true"]',
      );

      menuItems.forEach((item) => {
        item.addEventListener("click", function (event) {
          event.preventDefault();

          // Vérifier l'état de l'élément (déplié ou replié)
          const isExpanded = item.getAttribute("aria-expanded") === "true";
          item.setAttribute("aria-expanded", !isExpanded);

          // Trouver le sous-menu et afficher/masquer selon l'état
          const subMenu = item.nextElementSibling;
          if (subMenu) {
            if (isExpanded) {
              subMenu.style.display = "none";
            } else {
              subMenu.style.display = "block";
            }
          }
        });
      });
    });
  },
};

export default menu;
